import { render, staticRenderFns } from "./FrameAvoir.vue?vue&type=template&id=0a717ab0&scoped=true"
import script from "./FrameAvoir.vue?vue&type=script&lang=js"
export * from "./FrameAvoir.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a717ab0",
  null
  
)

export default component.exports